import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Select2OptionData } from "ng-select2";
import { ToastrService } from "ngx-toastr";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddUpdateMerchantViewModel } from "../../models/add-update-merchant-view-model";
import { BankingDetailsViewModel } from "../../models/banking-details-view-model";
import { CardAcceptorConfigViewModel } from '../../models/card-acceptor-config-view-model';
import { ContactDetailsViewModel } from '../../models/contact-details-view-model';
import { CreateResult } from "../../models/create-result";
import { SinkNodeMappedFieldsViewModel } from '../../models/sinknode-mapped-fields-view-model';
import { UpdateCommissionDetailsViewModel } from '../../models/update-commission-details-view-model';
import { VASCustomerBalanceViewModel } from '../../models/vas-customer-balance-view-model';
import { CardAcceptorConfigService } from "../../services/card-acceptor-config.service";
import { AccessPolicyEnum, PermissionEnum } from "../../services/guards/permissions";
import { MerchantService } from "../../services/merchant.service";
import { UserDataStoreService } from "../../services/user-data-store.service";
import { AuthenticationService } from "../../services/authentication.service";
import { SinkNodeMappingConfigViewModel } from "../../models/sinknode-mapping-config-view-model";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ParticipantService } from "../../services/participant.service";
import { MerchantDetailModel } from '../../models/merchant-detail-model';
import { HttpClient } from '@angular/common/http';
import { ParticipantViewModel } from 'src/app/models/participant-view-model';
import { CountryViewModel } from '../../models/country-view-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { DataTableDirective } from 'angular-datatables';
import { merchantParamsModel } from 'src/app/models/merchant-params-model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ServiceParameterModel } from 'src/app/models/service-parameter-model';
import { ServiceParameterService } from 'src/app/services/service-parameter.service';
@Component({
  selector: 'app-merchant-view',
  templateUrl: './merchant-view.component.html',
  styleUrls: ['./merchant-view.component.scss']
})
export class MerchantViewComponent implements OnInit, OnDestroy {
  @ViewChild('serviceSelect') serviceSelect: NgSelectComponent;

  public addUpdateMerchant: AddUpdateMerchantViewModel;
  public bankingDetails: BankingDetailsViewModel;
  public contactDetails: ContactDetailsViewModel;
  public commissionDetails: UpdateCommissionDetailsViewModel[];
  public sinkNodeMappedFields: SinkNodeMappedFieldsViewModel[] = [];
  public sinkNodeMappingConfigs: SinkNodeMappingConfigViewModel[] = [];
  public vasCustomerBalanceDetails: VASCustomerBalanceViewModel;
  public merchantDetails: MerchantDetailModel;
  public participantDetails: ParticipantViewModel;
  public countryDetails: CountryViewModel;
  public createResult: CreateResult;
  public merchantNumber: FormControl;
  public cardAcceptorConfigFormControl: FormControl;
  public cardAcceptorConfig;
  public shopName: FormControl;
  public city: FormControl;
  public town: FormControl;
  public postalServiceCode: FormControl; // the field added from terminal config
  public slipHeader: FormControl;
  public slipTrailer: FormControl;
  public subMerchantId: FormControl;
  public independentSalesOrganizationId: FormControl;
  public independentSalesOrganizationIdVisa: FormControl;
  public paymentFacilitatorId: FormControl;
  public paymentFacilitatorIdVisa: FormControl;
  public merchanCountryofOrigin: FormControl;
  public customerServicePhoneNo: FormControl;
  public merchantStreetAddress: FormControl;
  public merchantVerificationValue: FormControl;
  public cardSetFormControl: FormControl;
  public commissionFormControl: FormControl;
  public countryFormControl: FormControl;
  public countryOfCodeFormControl: FormControl;
  public governmentalConditionFormControl: FormControl;
  public regionFormControl: FormControl;
  public merchantTypeFormControl: FormControl;
  public accountHolderName: FormControl;
  public accountDescription: FormControl;
  public bankFormControl: FormControl;
  public accountTypeFormControl: FormControl;
  public branchCode: FormControl;
  public branchName: FormControl;
  public accountNumber: FormControl;
  public contactName: FormControl;
  public contactSurname: FormControl;
  public contactNumber: FormControl;
  public cellNumber: FormControl;
  public emailAddress: FormControl;
  public url: FormControl;
  public loyaltyCommission: FormControl;
  public serviceFormControl: FormControl;
  public merchantParamsFC: { formControl: FormControl, merchantParam: merchantParamsModel, serviceParameter: ServiceParameterModel }[] = [];
  public commissionFC: { formControl: FormControl, commissionDetails: UpdateCommissionDetailsViewModel }[] = [];
  public lowBalanceThreshold: FormControl;
  public customerSystemID: FormControl;
  public currentBalance: FormControl;
  public sinkNodeMappedFieldsFormControl: FormControl;
  public lowBalanceNotificationStatus: FormControl;
  public mappedFieldsFC: { formControl: FormControl, sinkNodeMappedFields: SinkNodeMappedFieldsViewModel, disabled: boolean }[] = [];
  public cardSets: Select2OptionData[];
  public countries: Select2OptionData[];
  public regions: Select2OptionData[];
  public areas: Select2OptionData[] = []; //added by lebohang for automization of cities
  public selectedArea: string = '';
  public areaData = [];
  public areaDataReserve = [];
  public lowBalance: boolean = false;
  public raiseErrors: boolean = false;
  public errorMessage: string;
  public formatSlipHeader: string;
  public formatSlipTrailer: string;
  public isoPfiMappedDescription: string = '';

  public governmentalOptions: Select2OptionData[] = [
    { id: "Yes", text: 'Yes' },
    { id: "No", text: 'No' }
  ];

  public merchantParams: merchantParamsModel[] = [];

  areaBuffer = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  public merchantTypes: Select2OptionData[];
  public banks: Select2OptionData[];
  public accountTypes: Select2OptionData[];
  public cardAcceptorConfigs: Select2OptionData[];
  public services: Select2OptionData[];

  public get cardTypes(): Select2OptionData[] {
    const items = [
      { id: "1", text: 'Debit' },
      { id: "2", text: 'Credit' },
      { id: "3", text: 'AMEX' },
      { id: "4", text: 'Diners' },
      { id: "5", text: 'RCS' },
      { id: "6", text: 'Giftcard' }
    ];

    if (!!this.commissionDetails) {
      for (const item of this.commissionDetails) {
        const index = items.findIndex(x => x.id == item.cardID.toString());
        if (index > -1) {
          items.splice(index, 1);
        }
      }
    }
    return items;
  }

  public get mappedFields(): Select2OptionData[] {
    if (this.sinkNodeMappingConfigs && this.sinkNodeMappingConfigs.length > 0) {
      return this.sinkNodeMappingConfigs
        .filter(field => !this.mappedFieldsFC.find(fieldFC => fieldFC.sinkNodeMappedFields.sinkNode == field.id.toString()))
        .map(
          s => ({
            id: s.id.toString(),
            text: s.mapDescription
          })
        );
    }
    return [];
  }

  public disabled = false;

  private _destroyed$ = new Subject<any>();
  public error = false;
  public validateError = false;
  public submitted = false;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public creatingNew = false;
  public saveMerchantDetails = false;
  public creatingNewBankingDetail = true;
  public creatingNewContactDetail = true;
  public creatingNewVASDetails = true;
  public cardAcceptorConfigList: CardAcceptorConfigViewModel[];

  public canEdit = false
  public canView = false;
  public canAdd = false;
  public canConfigLoyaltyCommission = false;
  public displayContent = false;

  public displayCustomerServicePhoneNo = false;
  public displayMerchantStreetAddress = false;
  public displayIndependentSalesOrganizationId = false;
  public displayPaymentFacilitatorIdVisa = false;
  public displayPaymentFacilitatorId = false;
  public displaySubMerchantId = false;
  public displayIndependentSalesOrganizationIdVisa = false;
  public displayMerchantVerificationValue = false;

  public displayCountryCode = false;
  public displayIsoContentError = false;
  public AddEditButton: string;

  public PostTerm = 2;
  public TermApp = 1;
  public CardAcceptorConfigType: number;
  public loaded = false;
  public warning: string;
  public raiseWarning: boolean;
  public viewOnlyRight: string;
  public raiseSinkNodeMappingWarningMessage: string;
  public raiseSinkNodeMappingWarning: boolean;
  public newMerchantCreation: boolean;

  public viewBanking = false
  public viewContact = false;
  public viewCommission = false;
  public viewAddedServices = false;
  public hideCustomServices = true;
  public removePFIForAggregatorModel = false;
  public enableCustomNedbankPFI = false;
  public enableAbsaBase24SaPFI = false;
  public totalCommissionDetails: number;
  public totalMappedFieldsDetails: number;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public globalSearch = false;
  textValue: string;
  public counter: number;

  constructor(
    private _route: ActivatedRoute,
    private _merchantService: MerchantService,
    private _serviceParameterService: ServiceParameterService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private fb: FormBuilder,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _router: Router,
    private _participantService: ParticipantService,
    private _http: HttpClient,
    private _modalService: NgbModal) {
    if (sessionStorage.getItem('merchantGlobalSearch') === 'true') {
      this.globalSearch = true;
    } else {
      this.globalSearch = false;
    }
  }


  public async ngOnInit(): Promise<void> {
    this.merchantNumber = new FormControl('', Validators.compose([Validators.required, Validators.minLength(15), Validators.maxLength(15)]));
    this.cardAcceptorConfigFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.shopName = new FormControl('', Validators.compose([Validators.required]));
    this.city = new FormControl('', Validators.compose([Validators.required]));
    this.town = new FormControl('');
    this.postalServiceCode = new FormControl('', Validators.compose([Validators.required]));
    this.slipHeader = new FormControl('');
    this.slipTrailer = new FormControl('');
    this.cardSetFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.countryFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.countryOfCodeFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.regionFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.merchantTypeFormControl = new FormControl('', Validators.compose([Validators.required]));
    this.independentSalesOrganizationId = new FormControl('', Validators.compose([Validators.minLength(11), Validators.maxLength(11)]));
    this.independentSalesOrganizationIdVisa = new FormControl('', Validators.compose([Validators.minLength(11), Validators.maxLength(11)]));
    this.paymentFacilitatorId = new FormControl('', Validators.compose([Validators.maxLength(11)]));
    this.paymentFacilitatorIdVisa = new FormControl('', Validators.compose([Validators.maxLength(11)]));
    this.subMerchantId = new FormControl('', Validators.compose([Validators.minLength(15), Validators.maxLength(15)]));
    this.merchanCountryofOrigin = new FormControl('');
    this.customerServicePhoneNo = new FormControl('', Validators.compose([Validators.minLength(11), Validators.maxLength(11)]));
    this.merchantStreetAddress = new FormControl('', Validators.compose([Validators.maxLength(48)]));
    this.merchantVerificationValue = new FormControl('', Validators.compose([Validators.minLength(10), Validators.maxLength(10)]));

    this.governmentalConditionFormControl = new FormControl('');
    this.accountHolderName = new FormControl('');
    this.accountDescription = new FormControl('');
    this.bankFormControl = new FormControl('');
    this.accountTypeFormControl = new FormControl('');
    this.branchCode = new FormControl('', Validators.compose([Validators.required, Validators.maxLength(10), Validators.pattern(/^0*[1-9]\d*$/)]));
    this.branchName = new FormControl('');
    this.accountNumber = new FormControl('', Validators.compose([Validators.minLength(9), Validators.maxLength(15), Validators.pattern(/^0*[1-9]\d*$/)]));
    this.contactName = new FormControl('');
    this.contactSurname = new FormControl('');
    this.contactNumber = new FormControl('');
    this.cellNumber = new FormControl('');
    this.emailAddress = new FormControl('', Validators.compose([Validators.email]));
    this.url = new FormControl('');
    this.commissionFormControl = new FormControl('');
    this.serviceFormControl = new FormControl('');
    this.loyaltyCommission = new FormControl('');
    this.lowBalanceThreshold = new FormControl('');
    this.customerSystemID = new FormControl('');
    this.currentBalance = new FormControl('');
    this.lowBalanceNotificationStatus = new FormControl('');
    this.sinkNodeMappedFieldsFormControl = new FormControl('');

    this.countries = (await this._merchantService.GetCountries()).map((x) => {
      return { id: x.countryCode, text: x.country }
    });

    this.regions = (await this._merchantService.GetRegions()).map((x) => {
      return { id: x.regionCode, text: x.regionName }
    });

    this.merchantTypes = (await this._merchantService.GetMerchantTypes()).map((x) => {
      return { id: x.code, text: `${x.code} - (${x.displayName})` }
    });

    this.getCodes('ZA');
    this.canConfigLoyaltyCommission = this._userDataStore.hasRequiredPermissions([PermissionEnum.ConfigureLoyaltyCommission], [AccessPolicyEnum.ConfigLoyaltyCommission])
    this.initMerchant();
  }

  public async initMerchant(): Promise<void> {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchant], []);
    this.loadMerchantSettings(this._userDataStore.selectedParticipant);

    this.enableCustomNedbankPFI = await this._participantService.GetEnableCustomNedbankPFI();
    this.enableAbsaBase24SaPFI = await this._participantService.GetEnableAbsaBase24SaPFI();

    this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchant], []);
      if (!this.canView) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      if (params.id != 'new') {
        this._ngxUiLoaderService.start();

        await this.getMerchantServices("" + params.id);

        this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchant], []);
        this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchant], []);
        this.disabled = true;
        this.creatingNew = false;

        //disable controls
        this.merchantNumber.disable();
        this.city.disable();
        //this.town.disable();
        this.addUpdateMerchant = await this._merchantService.Get(params.id);
        if (!!this.addUpdateMerchant) {
          if (!!this.addUpdateMerchant.merchantNumber) { //To do : Retrieve postal service code from merchant details table

            this.countryDetails = await this._merchantService.GetCountryDetails(this.addUpdateMerchant.countryCode);

            let getRegions = await this._merchantService.GetRegionsByCountry(this.countryDetails?.country);
            if (getRegions == null) {
              this.regions = (await this._merchantService.GetRegions()).map((x) => {
                return { id: x.regionCode, text: x.regionName }
              });
            } else {
              this.regions = (getRegions).map((x) => {
                return { id: x.regionCode, text: x.regionName }
              });
            }

            this.getCodes(this.countryDetails?.country);

            if (this.globalSearch) {
              this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetByParticipant(this.addUpdateMerchant.participantId);
              this.cardSets = (await this._merchantService.GetCardSetsByMerchant(this.addUpdateMerchant.merchantNumber)).map((x) => {
                return { id: x.cardSet, text: x.cardSet }
              });
              const participant = await this._merchantService.GetMerchantSettings(this.addUpdateMerchant.merchantNumber);
              this.loadMerchantSettings(participant);
            }
            else {
              this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetAllConfigs();
              this.cardSets = (await this._merchantService.GetCardSetsByParticipant(this._userDataStore.selectedParticipant.id)).map((x) => {
                return { id: x.cardSet, text: x.cardSet }
              });
            }

            //if (this.merchantDetails == null) {
            this.merchantDetails = await this._merchantService.GetMerchantDetails(this.addUpdateMerchant.merchantNumber);
            //}
          }

          this.cardAcceptorConfigFormControl.setValue(this.addUpdateMerchant.cardAcceptorConfigId);
          this.shopName.setValue(this.addUpdateMerchant.shopName);
          this.city.setValue(this.addUpdateMerchant.city);
          this.selectedArea = this.addUpdateMerchant.city; // This a placeholder for the dropdown controller;
          this.town.setValue(this.addUpdateMerchant.town);
          this.postalServiceCode.setValue(this.merchantDetails == null ? '' : this.merchantDetails.postalServiceCode);
          this.regionFormControl.setValue(this.addUpdateMerchant.regionCode); // <-- Ensure region is set from loaded data
          this.independentSalesOrganizationId.setValue(this.merchantDetails == null ? '' : this.merchantDetails.independentSalesOrgId);
          this.independentSalesOrganizationIdVisa.setValue(this.merchantDetails == null ? '' : this.merchantDetails.independentSalesOrgIdVisa);
          this.paymentFacilitatorId.setValue(this.merchantDetails == null ? '' : this.merchantDetails.paymentFacilitatorId);
          this.paymentFacilitatorIdVisa.setValue(this.merchantDetails == null ? '' : this.merchantDetails.paymentFacilitatorIdVisa);
          this.subMerchantId.setValue(this.merchantDetails == null ? '' : this.merchantDetails.subMerchantId);
          this.customerServicePhoneNo.setValue(this.merchantDetails == null ? '' : this.merchantDetails.customerServicePhoneNo);
          this.merchantStreetAddress.setValue(this.merchantDetails == null ? '' : this.merchantDetails.merchantStreetAddress);
          this.merchantVerificationValue.setValue(this.merchantDetails == null ? '' : this.merchantDetails.merchantVerificationValue);

          this.governmentalConditionFormControl.setValue(this.merchantDetails == null ? '' : (this.merchantDetails.isGovernmentalMerchant == true ? 'Yes' : 'No'))

          this.slipHeader.setValue(this.addUpdateMerchant.slipHeader.replace(/\\n/g, '\n'));
          this.formatSlipHeader = this.addUpdateMerchant.slipHeader.replace(/\n/g, "\\n");
          this.slipTrailer.setValue(this.addUpdateMerchant.slipTrailer.replace(/\\n/g, '\n'));
          this.formatSlipTrailer = this.addUpdateMerchant.slipTrailer.replace(/\n/g, "\\n");
          this.cardSetFormControl.setValue(this.addUpdateMerchant.cardSet);
          this.cardSetFormControl.markAsPristine();
          this.countryFormControl.setValue(this.addUpdateMerchant.countryCode);
          this.countryFormControl.markAsPristine();

          if (!!this.countryDetails) {
            this.countryOfCodeFormControl.setValue(this.countryDetails.currencyCode);
          }

          // this.regionFormControl.setValue(this.addUpdateMerchant.regionCode); // Already set above
          this.regionFormControl.markAsPristine();
          this.merchantTypeFormControl.setValue(this.addUpdateMerchant.merchantType);
          this.merchantTypeFormControl.markAsPristine();
          this.updateForm();
          if (this.addUpdateMerchant.merchantNumber !== '') {
            var isoPfiSinkNode = await this._merchantService.GetISOPfiSinkNode(this.addUpdateMerchant.merchantNumber);
            if (isoPfiSinkNode) {
              this.isoPfiMappedDescription = isoPfiSinkNode.description;
            }
          }
        }

        //disable controls
        if (!this.canEdit && this.canView) {
          //this._toastService.warning("Please note that you do not have the required permissions to update a terminal config.", "Warning");
          this.warning = "Please note that you do not have the required permissions to update this page";
          this.raiseWarning = false;//changed to false

          this.viewOnlyRight = "display:none";
          //Merchant
          this.AddEditButton = "display:none";
          this.merchantNumber.disable();
          this.cardAcceptorConfigFormControl.disable();
          this.shopName.disable();
          this.city.disable();
          this.town.disable();
          this.postalServiceCode.disable();
          this.slipHeader.disable();
          this.slipTrailer.disable();
          this.cardSetFormControl.disable();
          this.countryFormControl.disable();
          this.regionFormControl.disable();
          this.merchantTypeFormControl.disable();
          //Banking

          this.accountDescription.disable();
          this.accountHolderName.disable();
          this.bankFormControl.disable();
          this.accountTypeFormControl.disable();
          this.branchCode.disable();
          this.accountNumber.disable();
          this.branchName.disable();
          this.loyaltyCommission.disable();

          //Contact
          this.contactName.disable();
          this.contactSurname.disable();
          this.contactNumber.disable();
          this.cellNumber.disable();
          this.emailAddress.disable();
          this.url.disable();

          //VAS
          this.lowBalanceThreshold.disable();
          this.customerSystemID.disable();
          this.currentBalance.disable();
          this.lowBalanceNotificationStatus.disable();

          //buttons
          this.sinkNodeMappedFieldsFormControl.disable();
          this.commissionFormControl.disable();
        }

        this._ngxUiLoaderService.stop();

      }
      else {

        this.initDefaults();
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddMerchant], []);
        if (!this.canAdd) {
          this._toastService.warning("Please note that you do not have the required permissions to Edit/Save this page.", "Warning");
          this.AddEditButton = "display:none";
        }

        this.participantDetails = await this._participantService.GetAggregateMerchant(this._userDataStore.selectedParticipant.id);

        if (this.globalSearch && this.merchantDetails !== null) {
          this.participantDetails = await this._participantService.GetAggregateMerchant(this.merchantDetails.participantId);
          if (this.cardAcceptorConfigList == undefined || this.cardAcceptorConfigList == null) {
            this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetByParticipant(this.merchantDetails.participantId);
            this.cardAcceptorConfigs = (this.cardAcceptorConfigList).map((x) => {
              return { id: x.id.toString(), text: x.name }
            });
          }
        } else {
          this.participantDetails = await this._participantService.GetAggregateMerchant(this._userDataStore.selectedParticipant.id);
          this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetAllConfigs();
          this.cardAcceptorConfigs = (this.cardAcceptorConfigList).map((x) => {
            return { id: x.id.toString(), text: x.name }
          });
        }

        this.cardSets = (await this._merchantService.GetCardSetsByParticipant(this._userDataStore.selectedParticipant.id)).map((x) => {
          return { id: x.cardSet, text: x.cardSet }
        });

        this.addUpdateMerchant = {
          merchantNumber: '',
          shopName: '',
          slipHeader: '',
          slipTrailer: '',
          cardSet: '',
          merchantType: '',
          regionCode: '',
          city: '',
          town: '',
          postalServiceCode: '',
          independentSalesOrgId: '',
          independentSalesOrgIdVisa: '',
          paymentFacilitatorId: '',
          paymentFacilitatorIdVisa: '',
          subMerchantId: '',
          customerServicePhoneNo: '',
          merchantStreetAddress: '',
          merchantVerificationValue: '',
          countryCode: this.countryFormControl.value ? this.countryFormControl.value.id : '',
          cardAcceptorConfigId: 0,
          participantId: 0,
          isGovernmentalMerchant: false

        }

        this.bankingDetails = {
          accountDescription: '',
          accountHolderName: '',
          accountNr: '',
          accountTypeID: 0,
          bankID: 0,
          branchCode: '',
          branchName: '',
          merchantNr: '',
          commission: 0
        }

        this.contactDetails = {
          directNumber: '',
          emailAddress: '',
          faxNumber: '',
          firstName: '',
          jobTitle: '',
          merchantNr: '',
          mobileNumber: '',
          surname: '',
          workNumber: '',
          url: ''
        }

        this.vasCustomerBalanceDetails = {
          currentBalance: 0,
          customerBalanceID: 0,
          customerSystemID: '',
          lowBalanceNotificationStatus: 0,
          lowBalanceThreshold: 0
        }

        this.hideCustomServices = true;

        this.creatingNew = true;
        this.loaded = true;

      }

    });
  }

  public async initTable(selectedIndex: number): Promise<void> {
    await this._loadTabData(selectedIndex);
  }

  private async GetSinkNodeMappedConfigs(): Promise<SinkNodeMappingConfigViewModel[]> {
    var result = [];
    if (this.globalSearch && this.merchantDetails !== null) {
      result = await this._participantService.GetSinkNodeMappedConfigsByMerchant(this.merchantDetails.merchantNumber);
    } else {
      result = await this._participantService.GetSinkNodeMappedConfigs();
    }
    return result.filter(x => x.mapDescription !== 'Aggregator' && x.mapDescription !== 'Mapped_ISO' && x.mapDescription !== 'ISO PFI');
  }

  private async _loadTabData(index: number): Promise<void> {

    switch (index) {
      case 2:
        this.banks = (await this._merchantService.GetBanks()).map((x) => {
          return { id: x.bankID.toString(), text: x.bankName }
        });
        this.accountTypes = (await this._merchantService.GetAccountTypes()).map((x) => {
          return { id: x.accountTypeID.toString(), text: x.typeName }
        });
        this.bankingDetails = await this._merchantService.GetBankingDetails(this.addUpdateMerchant.merchantNumber, this._userDataStore.selectedParticipant.id.toString());
        if (!!this.bankingDetails && this.bankingDetails.accountNr != null) {
          this.accountDescription.setValue(this.bankingDetails.accountDescription);
          this.accountHolderName.setValue(this.bankingDetails.accountHolderName);
          this.bankFormControl.setValue(this.bankingDetails.bankID.toString());
          this.bankFormControl.markAsPristine();
          this.accountTypeFormControl.setValue(this.bankingDetails.accountTypeID.toString());
          this.accountTypeFormControl.markAsPristine();
          this.branchCode.setValue(this.bankingDetails.branchCode);
          this.accountNumber.setValue(this.bankingDetails.accountNr);
          this.branchName.setValue(this.bankingDetails.branchName);
          this.loyaltyCommission.setValue(this.bankingDetails.commission);
        }

        break;
      case 3:

        this.contactDetails = await this._merchantService.GetContactDetails(this.addUpdateMerchant.merchantNumber, this._userDataStore.selectedParticipant.id.toString());
        if (!!this.contactDetails) {
          this.contactName.setValue(this.contactDetails.firstName);
          this.contactSurname.setValue(this.contactDetails.surname);
          this.contactNumber.setValue(this.contactDetails.directNumber);
          this.cellNumber.setValue(this.contactDetails.mobileNumber);
          this.emailAddress.setValue(this.contactDetails.emailAddress);
          this.url.setValue(this.contactDetails.url);
        }
        break;
      case 4:
        this.commissionDetails = await this._merchantService.GetCommissionDetails(this.addUpdateMerchant.merchantNumber);
        this.totalCommissionDetails = this.commissionDetails.length;
        if (!!this.commissionDetails) {

          this.commissionFC.length = 0;

          for (const item of this.commissionDetails) {
            const commission = new FormControl();
            commission.setValue(item.commission);
            if (!this.canEdit && this.canView) {
              commission.disable();
            }
            this.commissionFC.push({
              formControl: commission,
              commissionDetails: item
            });
          }
        }
        break;
      case 5:
        this.vasCustomerBalanceDetails = await this._merchantService.GetVASCustomerBalanceDetails(this.addUpdateMerchant.merchantNumber);
        if (!!this.vasCustomerBalanceDetails) {
          this.lowBalanceThreshold.setValue(this.vasCustomerBalanceDetails.lowBalanceThreshold);
          this.customerSystemID.setValue(this.vasCustomerBalanceDetails.customerSystemID);
          this.currentBalance.setValue(this.vasCustomerBalanceDetails.currentBalance);
          this.lowBalanceNotificationStatus.setValue(this.vasCustomerBalanceDetails.lowBalanceNotificationStatus);
          //Set VAS notification
          if (this.vasCustomerBalanceDetails.currentBalance <= this.vasCustomerBalanceDetails.lowBalanceThreshold) {
            this.lowBalance = true;
          }
        }
        break;
      case 6:
        await this.getMerchantParams();
        break;
      default:

        this.merchantDetails = await this._merchantService.GetMerchantDetails(this.addUpdateMerchant.merchantNumber);
        this.participantDetails = await this._participantService.GetAggregateMerchant(this.addUpdateMerchant.participantId);

        var sinkNodes = await this.loadSinkNodeMappedFields();
        this.sinkNodeMappedFields = sinkNodes;
        this.totalMappedFieldsDetails = sinkNodes.length;

        this.sinkNodeMappingConfigs = await this.GetSinkNodeMappedConfigs();

        var snkNodeList = this.sinkNodeMappingConfigs;
        for (var i = 0; i < snkNodeList.length; i++) {
          if (snkNodeList[i].mapDescription == 'Aggregator' || snkNodeList[i].mapDescription == 'Mapped_ISO' || snkNodeList[i].mapDescription == 'ISO PFI') {
          } else {
            //Prevent item from being added multiple times
            var itemExist = this.sinkNodeMappingConfigs.filter(x => x.mapDescription == snkNodeList[i].mapDescription);
            if (itemExist.length == 0) {
              this.sinkNodeMappingConfigs.push(snkNodeList[i]);
            }
          }
        }

        if (this.sinkNodeMappedFields) {
          await this.loadMappedDescriptions();
        }

        if (this.sinkNodeMappingConfigs && this.sinkNodeMappingConfigs.length > 0) {
          this.sinkNodeMappingConfigs = this.sinkNodeMappingConfigs
            .filter(x => !this.mappedFieldsFC.find(y => y.sinkNodeMappedFields.description == x.mapDescription));
        } else if (this.sinkNodeMappingConfigs?.length == 0 && this.sinkNodeMappedFields?.length > 0) {
          if (this.sinkNodeMappedFields?.length == 1) {
            if (this.sinkNodeMappedFields[0].description != "Mapped_ISO") {
              this.raiseSinkNodeMappingWarning = true;
              this.raiseSinkNodeMappingWarningMessage = "Please contact system administrator to setup Sink Node Mapping configurations.";
            } else {
              this.sinkNodeMappingConfigs.length = 1;
            }
          } else {
            this.raiseSinkNodeMappingWarning = true;
            this.raiseSinkNodeMappingWarningMessage = "Please contact system administrator to setup Sink Node Mapping configurations.";
          }
        } else {
          this.raiseSinkNodeMappingWarning = false
        }

        this.merchantNumber.setValue(this.addUpdateMerchant.merchantNumber);
    }
  }

  rerender(): void {
    //
    if ("dtInstance" in this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destroy the table first
        dtInstance.destroy();
        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }


  public async initDefaults() {
    debugger;
    var country = await this._merchantService.GetDefaultCountry();
    const defaultCountry = country.countryCode;//'ZA';
    this.countryFormControl.setValue(defaultCountry);
    this.updateCountryCodeValue(defaultCountry);
    this.getCodes(country.country);
  }

  public getCodes(countryName: string) {
    let codePath: string = "";

    // Dynamically determine the path based on the country name or code
    switch (countryName) {
      case "South Africa":
        codePath = "assets/data/areas.json"
        break;
      case "Namibia":
        codePath = "assets/data/namibian_areas.json";
        break;
      default:
        codePath = "assets/data/areas.json";
    }

    this._http.get(codePath).subscribe((data: any[]) => {
      this.areaData = data;
      this.areaBuffer = this.areaData.slice(0, this.bufferSize);
      this.areaDataReserve = data;
    });

    //clear selected city
    this.selectedArea = '';
  }

  public loadAreas(selectedId: string): void {
    debugger;

    const selectedRegion = this.regions.find(r => r.id === selectedId);
    const regionText = selectedRegion?.text;


    this.areaData = [];
    this.areaData = this.areaDataReserve;
    this.regionFormControl.setValue(selectedId);

    if (this.countryFormControl.value == "NA") {
      var list = this.areaData
        .filter(c => c.Region === regionText)
        //.filter(c => c.Area === 'Windhoek')
        //.map(c => ({ id: c.Suburb, text: c.Area }));
        .map(x => ({
          Suburb: x.Suburb, StrCode: x.StrCode, Area: x.Area
        }));
      //this.selectedArea
      this.areaData = list;
    }

  }

  onCitySelected(cityValue) {
    if (cityValue == null) {
      this.city.setValue('');
      this.postalServiceCode.setValue('');
    } else {
      if (cityValue['StrCode']) {
        this.city.setValue(cityValue['Area']);
        //this.postalServiceCode.setValue(cityValue['StrCode']);
        this.postalServiceCode.setValue(cityValue['StrCode']?.slice(0, 4));
      } else {
        this.city.setValue(cityValue['Area']);
        //this.postalServiceCode.setValue(cityValue['BoxCode']);
        this.postalServiceCode.setValue(cityValue['BoxCode']?.slice(0, 4));
      }
    }
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({ end }) {
    if (this.loading || this.areaData.length <= this.areaBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.areaBuffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.areaBuffer.length;
    const more = this.areaData.slice(len, this.bufferSize + len);
    this.loading = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading = false;
      this.areaBuffer = this.areaBuffer.concat(more);
    }, 200)
  }

  public onBanking(): void {
    if (this.creatingNew && this.accountTypeFormControl.touched) {
      this.creatingNewBankingDetail = true;
    }
  }

  public async getMerchantServices(merchantNumber: string): Promise<void> {
    this.services = (await this._merchantService.GetMerchantServices(merchantNumber)).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });
    if (this.services.length > 0) {
      this.hideCustomServices = false;
    }
  }

  public async getMerchantParams(): Promise<void> {
    this.merchantParamsFC = [];
    this.merchantParams = await this._merchantService.GetMerchantParams(this.addUpdateMerchant.merchantNumber);

    this.merchantParams.forEach(async (param: merchantParamsModel) => {
      const fc = new FormControl();
      fc.setValue(param.value);
      let serviceParameter = await this._serviceParameterService.GetServiceParameter(param.service.id);
      this.services = this.services.filter(x => x.id !== (param.service.id).toString());
      this.merchantParamsFC.push({ formControl: fc, merchantParam: param, serviceParameter: serviceParameter });
    });
    if (this.merchantParams.length > 0) {
      this.hideCustomServices = false;
    }
  }

  public async addMerchantParam(): Promise<void> {
    if (!!this.serviceFormControl) {
      const param: merchantParamsModel = {
        id: 0,
        value: '',
        merchantNumber: this.addUpdateMerchant.merchantNumber,
        service: {
          id: this.serviceFormControl.value,
          name: this.services.find(x => x.id == this.serviceFormControl.value.toString()).text
        }
      };
      const fc = new FormControl();
      fc.setValue(param.id);
      this.services = this.services.filter(x => x.id !== this.serviceFormControl.value);
      this.serviceSelect.handleClearClick();
      this.merchantParams.push(param);
      let serviceParameter = await this._serviceParameterService.GetServiceParameter(param.service.id);
      this.merchantParamsFC.push({ formControl: fc, merchantParam: param, serviceParameter: serviceParameter });
    }
  }

  public async deleteMerchantParam(id: number): Promise<void> {
    const index = this.merchantParamsFC.findIndex(x => x.merchantParam.service.id == id);
    if (index > -1) {
      if (this.merchantParamsFC[index].merchantParam.id > 0) {
        let result = await this._merchantService.DeleteMerchantParam(this.merchantParamsFC[index].merchantParam.id);
        if (!result.success) {
          return;
        }
      }

      let service = this.merchantParams[index].service;
      this.services.push({ id: service.id.toString(), text: service.name });
      this.serviceSelect.handleClearClick();
      this.merchantParams.splice(index, 1);
      this.merchantParamsFC.splice(index, 1);
    }
  }


  public addCommission(): void {

    if (!!this.commissionFormControl) {
      const com = {
        cardID: +this.commissionFormControl.value,
        commission: 0,
        name: this.cardTypes.find(x => x.id == this.commissionFormControl.value.toString()).text
      };
      const fc = new FormControl();
      fc.setValue(com.commission);

      this.commissionDetails = this.commissionDetails || [];
      this.commissionDetails.push(com);
      this.commissionFC.push({ commissionDetails: com, formControl: fc });
    }
  }

  public deleteCommission(id: number): void {
    const index = this.commissionDetails.findIndex(x => x.cardID == id);
    if (index > -1) {
      this.commissionDetails.splice(index, 1);
      this.commissionFC.splice(index, 1);
    }
  }

  public isCommissionDirty(): boolean {

    for (const comm of this.commissionFC) {
      if (comm.formControl.dirty == true) {
        return true;
      }
    }

    if (!!this.totalCommissionDetails) {
      if (this.commissionFC.length != this.totalCommissionDetails) {
        return true;
      }
    }
    return false;
  }

  public async addSinkNodeMappedFields(): Promise<void> {
    if (!!this.sinkNodeMappedFieldsFormControl) {
      const selectedOption = this.sinkNodeMappingConfigs.find(x => x.id == this.sinkNodeMappedFieldsFormControl.value.toString());
      const index = this.sinkNodeMappingConfigs.indexOf(selectedOption);
      const mappedFields = {
        sinkNode: selectedOption.sinknode,
        cardAcceptorId: this.addUpdateMerchant.merchantNumber,
        mappedAcquiringInst: '',
        mappedCardAcceptorId: '',
        description: this.mappedFields.find(x => x.id == this.sinkNodeMappedFieldsFormControl.value.toString()).text
      };
      const fc = new FormControl();
      fc.setValue(mappedFields.mappedCardAcceptorId);

      if (this.sinkNodeMappedFields != null) {
        if (this.sinkNodeMappedFields.length > 0) {
          var item = this.sinkNodeMappedFields.find(x => x.description == mappedFields.description)

          if (item != null) {
            this._toastService.error("Map description '" + mappedFields.description + "' already selected.", "Error");
            return;
          }
        }
      }

      this.sinkNodeMappedFields = this.sinkNodeMappedFields || [];
      this.sinkNodeMappedFields.push(mappedFields);
      this.sinkNodeMappingConfigs.splice(index, 1);
      this.mappedFieldsFC.push({ formControl: fc, sinkNodeMappedFields: mappedFields, disabled: false });
    }
  }

  public deleteMappedField(id: string): void {
    this.openDeleteConfirmationDialog(id);
  }

  public async updateForm(): Promise<void> {

    if (this.globalSearch && this.merchantDetails !== null) {
      this.participantDetails = await this._participantService.GetAggregateMerchant(this.merchantDetails.participantId);
      if ((this.cardAcceptorConfigList == undefined || this.cardAcceptorConfigList == null) || (this.cardAcceptorConfigs == null || this.cardAcceptorConfigs == undefined)) {
        this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetByParticipant(this.merchantDetails.participantId);
        this.cardAcceptorConfigs = (this.cardAcceptorConfigList).map((x) => {
          return { id: x.id.toString(), text: x.name }
        });
      }
    } else {
      this.participantDetails = await this._participantService.GetAggregateMerchant(this._userDataStore.selectedParticipant.id);

      this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetAllConfigs();
      this.cardAcceptorConfigs = (this.cardAcceptorConfigList).map((x) => {
        return { id: x.id.toString(), text: x.name }
      });
    }

    setTimeout(() => {

      const selectedCardAcceptorConfig = this.cardAcceptorConfigs.find((x) => {
        return +x.id == this.cardAcceptorConfigFormControl.value
      });

      const cardAcceptorConfig = this.cardAcceptorConfigList.find((x) => {
        return selectedCardAcceptorConfig && x.name == selectedCardAcceptorConfig.text
      });

      if (!!cardAcceptorConfig && (!!this.addUpdateMerchant.cardAcceptorConfigId || this.addUpdateMerchant.cardAcceptorConfigId === 0)) {
        this.CardAcceptorConfigType = cardAcceptorConfig.terminalConfigType;
      }

      if (cardAcceptorConfig.receiptGroupId === null) {
        this.displayContent = true;
      }

      if (cardAcceptorConfig.routingGroup.includes("ABSA") && (this.participantDetails.absaO1Token)) {
        this.AbsaO1TokenConfig();
        return;
      }

      if (cardAcceptorConfig.routingGroup.includes("ABSA") && this.enableAbsaBase24SaPFI == false) {
        this.AbsaConfig();
        return;
      }

      if (cardAcceptorConfig.routingGroup.includes("ABSA") && this.enableAbsaBase24SaPFI == true) {
        this.SetupAbsaForBase24();
        return;
      }

      if (this.enableCustomNedbankPFI && this.participantDetails.isAggregator == true && (cardAcceptorConfig.routingGroup.includes("Nedbank") || cardAcceptorConfig.routingGroup.includes("NedPost") || cardAcceptorConfig.routingGroup.includes("NedPB_RG") || cardAcceptorConfig.routingGroup.includes("Ned") || cardAcceptorConfig.routingGroup.includes("NupayRG"))) {
        this.NedbankConfig();
        return;
      }

      if (this.participantDetails.isAggregator == true && (this.participantDetails.removePFIDetails == null || this.participantDetails.removePFIDetails == false)) {
        this.AbsaConfig();
        return;
      }

      if (this.participantDetails.isAggregator == true && this.participantDetails.removePFIDetails == true) {
        this.hidePFI();
        return;
      }

      /*
     
      if ((this.participantDetails.isAggregator != null && this.participantDetails.isAggregator != false) || cardAcceptorConfig.routingGroup.includes('ABSA')) {
        if (cardAcceptorConfig.routingGroup.includes('ABSA')) {
          if (this.enableAbsaBase24SaPFI) {
            if (this.participantDetails.isAggregator == true) {
              this.displayPaymentFacilitatorId = true;
              this.displaySubMerchantId = true;
              this.displayPaymentFacilitatorIdVisa = true;
            }
            else {
              this.displayPaymentFacilitatorId = true;
              this.displayPaymentFacilitatorIdVisa = false;
              this.displaySubMerchantId = false;
              this.independentSalesOrganizationIdVisa.setValue('00000000000');
            }
          }
          else {
            this.displayPaymentFacilitatorId = true;
            this.displaySubMerchantId = true;
            this.displayPaymentFacilitatorIdVisa = true;
          }
     
          this.displayCustomerServicePhoneNo = true;
          this.displayMerchantStreetAddress = true;
          this.displayIndependentSalesOrganizationId = true;
          this.displayMerchantVerificationValue = false;
          //FOR ISO ID Visa
          if ((this.participantDetails.isAggregator == false || this.participantDetails.isAggregator == null))//ISO merchant
          {
            this.displayIndependentSalesOrganizationIdVisa = true;
          }
          else {
            this.independentSalesOrganizationId.setValue('00000000000');
          }
        }
        else if (cardAcceptorConfig.routingGroup.includes('Nedbank') || cardAcceptorConfig.routingGroup.includes('NedPost') || cardAcceptorConfig.routingGroup.includes('NedPB_RG') || cardAcceptorConfig.routingGroup.includes('Ned')) {
          if (!this.removePFIForAggregatorModel) {
            if (this.enableCustomNedbankPFI) {
              this.displayCustomerServicePhoneNo = false;
              this.displayMerchantStreetAddress = true;
              this.displayIndependentSalesOrganizationId = false;//Shaun has requested that this field is removed as per Postbridge SDP
              this.displayPaymentFacilitatorIdVisa = false;
              this.displayPaymentFacilitatorId = true;
              this.displaySubMerchantId = true;
              this.displayIndependentSalesOrganizationIdVisa = false;
              this.displayMerchantVerificationValue = true;
            }
            else {
              this.displayCustomerServicePhoneNo = true;
              this.displayMerchantStreetAddress = true;
              this.displayIndependentSalesOrganizationId = true;
              this.displayPaymentFacilitatorIdVisa = true;
              this.displayPaymentFacilitatorId = true;
              this.displaySubMerchantId = true;
              this.displayIndependentSalesOrganizationIdVisa = false;
              //for aggregator model
              if (this.participantDetails.isAggregator == true) {
                this.independentSalesOrganizationId.setValue('00000000000');
              }
              this.displayMerchantVerificationValue = false;
            }
          }
          else {
            if (this.enableCustomNedbankPFI) {
              this.displayCustomerServicePhoneNo = false;
              this.displayMerchantStreetAddress = true;
              this.displayIndependentSalesOrganizationId = false;
              this.displayPaymentFacilitatorIdVisa = false;
              this.displayPaymentFacilitatorId = true;
              this.displaySubMerchantId = true;
              this.displayIndependentSalesOrganizationIdVisa = false;
              this.displayMerchantVerificationValue = true;
            }
            else {
              //Hide all
              this.displayCustomerServicePhoneNo = false;
              this.displayMerchantStreetAddress = false;
              this.displayIndependentSalesOrganizationId = false;
              this.displayPaymentFacilitatorIdVisa = false;
              this.displayPaymentFacilitatorId = false;
              this.displaySubMerchantId = false;
              this.displayIndependentSalesOrganizationIdVisa = false;
              this.displayMerchantVerificationValue = false;
            }
          }
        }
        else {
          //any other bank that is an aggregator should display ABSA PFI only if the RemovePFIFlag is true
          if (!this.removePFIForAggregatorModel) {
            this.displayCustomerServicePhoneNo = true;
            this.displayMerchantStreetAddress = true;
            this.displayIndependentSalesOrganizationId = true;
            this.displayPaymentFacilitatorIdVisa = true;
            this.displayPaymentFacilitatorId = true;
            this.displaySubMerchantId = true;
            this.displayIndependentSalesOrganizationIdVisa = false;
            //for aggregator model
            if (this.participantDetails.isAggregator == true) {
              this.independentSalesOrganizationId.setValue('00000000000');
            }
            this.displayMerchantVerificationValue = false;
          }
          else {
            //Hide all
            this.displayCustomerServicePhoneNo = false;
            this.displayMerchantStreetAddress = false;
            this.displayIndependentSalesOrganizationId = false;
            this.displayPaymentFacilitatorIdVisa = false;
            this.displayPaymentFacilitatorId = false;
            this.displaySubMerchantId = false;
            this.displayIndependentSalesOrganizationIdVisa = false;
            this.displayMerchantVerificationValue = false;
          }
        }
      } else {
        //Hide all
        this.displayCustomerServicePhoneNo = false;
        this.displayMerchantStreetAddress = false;
        this.displayIndependentSalesOrganizationId = false;
        this.displayPaymentFacilitatorIdVisa = false;
        this.displayPaymentFacilitatorId = false;
        this.displaySubMerchantId = false;
        this.displayIndependentSalesOrganizationIdVisa = false;
        this.displayMerchantVerificationValue = false;
      }*/
    }, 2000);
  }

  public AbsaO1TokenConfig() {
    this.displaySubMerchantId = false;
    this.displayIndependentSalesOrganizationId = false;
    this.displayPaymentFacilitatorId = false;
    this.displayPaymentFacilitatorIdVisa = false;
    this.displayMerchantVerificationValue = false;
    this.displayCustomerServicePhoneNo = true;
    this.displayMerchantStreetAddress = true;
    this.displayIndependentSalesOrganizationIdVisa = false;

  }

  public AbsaConfig() {

    this.displaySubMerchantId = true;
    this.displayIndependentSalesOrganizationId = true;
    this.displayPaymentFacilitatorId = true;
    this.displayPaymentFacilitatorIdVisa = true;
    this.displayMerchantVerificationValue = false;
    this.displayCustomerServicePhoneNo = true;
    this.displayMerchantStreetAddress = true;

    //FOR ISO ID Visa
    if ((this._userDataStore.selectedParticipant.isAggregator == false || this._userDataStore.selectedParticipant.isAggregator == null)) {
      this.displayIndependentSalesOrganizationIdVisa = true;
    }
    else {
      this.displayIndependentSalesOrganizationIdVisa = false;
      this.independentSalesOrganizationId.setValue('00000000000');
    }
  }

  public SetupAbsaForBase24() {

    this.displayIndependentSalesOrganizationId = true;
    this.displayPaymentFacilitatorId = true;
    this.displayMerchantVerificationValue = false;
    this.displayCustomerServicePhoneNo = true;
    this.displayMerchantStreetAddress = true;

    //FOR ISO ID Visa
    if ((this._userDataStore.selectedParticipant.isAggregator == false || this._userDataStore.selectedParticipant.isAggregator == null)) {
      this.displayIndependentSalesOrganizationIdVisa = false;
      this.displaySubMerchantId = true;
      this.displayPaymentFacilitatorIdVisa = true;
    }
    else {
      this.independentSalesOrganizationId.setValue('00000000000');
      this.displayIndependentSalesOrganizationIdVisa = true;
      this.displaySubMerchantId = false;
      this.displayPaymentFacilitatorIdVisa = false;
    }

  }

  public NedbankConfig() {

    this.displaySubMerchantId = true;
    this.displayIndependentSalesOrganizationId = false;
    this.displayPaymentFacilitatorId = true;
    this.displayPaymentFacilitatorIdVisa = false;
    this.displayMerchantVerificationValue = true;
    this.displayCustomerServicePhoneNo = false;
    this.displayMerchantStreetAddress = true;
    this.displayIndependentSalesOrganizationIdVisa = false;

  }

  public OtherBanksConfig() {

    this.displaySubMerchantId = true;
    this.displayIndependentSalesOrganizationId = false;
    this.displayPaymentFacilitatorId = true;
    this.displayPaymentFacilitatorIdVisa = false;
    this.displayMerchantVerificationValue = true;
    this.displayCustomerServicePhoneNo = false;
    this.displayMerchantStreetAddress = false;
    this.displayIndependentSalesOrganizationIdVisa = false;

  }

  public SetupAggregator() {
    this.displayCustomerServicePhoneNo = true;
    this.displayMerchantStreetAddress = true;
    this.displayIndependentSalesOrganizationId = true;
    this.displayPaymentFacilitatorIdVisa = true;
    this.displayPaymentFacilitatorId = true;
    this.displaySubMerchantId = true;
    this.displayIndependentSalesOrganizationIdVisa = false;
    this.displayMerchantVerificationValue = false;
  }

  public hidePFI() {
    this.displayCustomerServicePhoneNo = false;
    this.displayMerchantStreetAddress = false;
    this.displayIndependentSalesOrganizationId = false;
    this.displayPaymentFacilitatorIdVisa = false;
    this.displayPaymentFacilitatorId = false;
    this.displaySubMerchantId = false;
    this.displayIndependentSalesOrganizationIdVisa = false;
    this.displayMerchantVerificationValue = false;

  }

  public async updateCountryCodeValue(event: string): Promise<void> {

    if (event) {
      // Clearing data and reseting forms
      this.regions = [];
      this.regionFormControl.setValue(null);
      this.city.setValue(null);
      this.town.setValue(null);
      this.postalServiceCode.setValue(null);

      this.countryDetails = await this._merchantService.GetCountryDetails(event);
      this.countryOfCodeFormControl.setValue(this.countryDetails?.currencyCode);

      var getRegions = await this._merchantService.GetRegionsByCountry(this.countryDetails?.country);//SA, NA
      if (getRegions == null) {
        this.regions = (await this._merchantService.GetRegions()).map((x) => {
          return { id: x.regionCode, text: x.regionName }
        });
      }
      else {
        this.regions = (getRegions).map((x) => {
          return { id: x.regionCode, text: x.regionName }
        });
      }
      this.getCodes(this.countryDetails?.country);
    }
  }

  public async updateFormValues(): Promise<void> {

    if (this.governmentalConditionFormControl.value == "Yes") {
      this.displayCountryCode = true;
      if (!!this.countryDetails) {
        this.countryOfCodeFormControl.setValue(this.countryDetails.currencyCode);
      } else {
        this.countryOfCodeFormControl.setValue("710");
      }
    } else {
      this.displayCountryCode = false;
      this.countryOfCodeFormControl.setValue("   ");
    }

    if (this.participantDetails != undefined && this.participantDetails != null) {
      if (!this.participantDetails.isAggregator) {
        //this.independentSalesOrganizationId.setValue(this.paymentFacilitatorId.value);
      }
    }
  }

  public markMerchantAsPrestine(): void {
    this.merchantTypeFormControl.markAsPristine();
    this.merchantNumber.markAsPristine();
    this.cardAcceptorConfigFormControl.markAsPristine();
    this.regionFormControl.markAsPristine();
    this.shopName.markAsPristine();
    this.city.markAsPristine();
    this.town.markAsPristine();
    this.postalServiceCode.markAsPristine();
    this.independentSalesOrganizationId.markAsPristine();
    this.independentSalesOrganizationIdVisa.markAsPristine();
    this.paymentFacilitatorId.markAsPristine();
    this.paymentFacilitatorIdVisa.markAsPristine();
    this.subMerchantId.markAsPristine();
    this.customerServicePhoneNo.markAsPristine();
    this.merchantStreetAddress.markAsPristine();
    this.merchantVerificationValue.markAsPristine();
    this.slipHeader.markAsPristine();
    this.slipTrailer.markAsPristine();
    this.countryFormControl.markAsPristine();
  }

  public markBankingAsPrestine(): void {
    this.accountHolderName.markAsPristine();
    this.accountDescription.markAsPristine();
    this.bankFormControl.markAsPristine();
    this.accountTypeFormControl.markAsPristine();
    this.branchCode.markAsPristine();
    this.accountNumber.markAsPristine();
    this.loyaltyCommission.markAsPristine();
  }

  public markSinkNodeAsPrestine(): void {
    for (const mappedFields of this.mappedFieldsFC) {
      mappedFields.formControl.markAsPristine();
    }
  }

  public markContactAsPrestine(): void {
    this.contactName.markAsPristine();
    this.contactSurname.markAsPristine();
    this.contactNumber.markAsPristine();
    this.cellNumber.markAsPristine();
    this.emailAddress.markAsPristine();
    this.url.markAsPristine();

  }

  public isMappedFieldsDirty(): boolean {
    for (const mappedFields of this.mappedFieldsFC) {
      if (mappedFields.formControl.dirty == true) {
        return true;
      }
    }
    if (!!this.totalMappedFieldsDetails) {
      if (this.mappedFieldsFC.length != this.totalMappedFieldsDetails) {
        return true;
      }
    }
    return false;
  }

  public removeCRLFCharacter(input): string {
    var output = '';
    for (var i = 0; i < input.length; i++) {
      if (input.charCodeAt(i) !== 13) {
        output = output + input[i];
      }
    }
    return output;
  }

  public omit_special_char(event) {
    let k = event.charCode;
    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 42 || k != 13) {
      this.shopName.reset(event.target.value);
    }
  }

  /*public onSlipHeaderChange(event: string) {
    this.formatSlipHeader = event.replace(/\n/g, "\\n");
    //this.slipHeader.setValue(value);
    //this.addUpdateMerchant.slipHeader = value;
  }
 
  public onSlipTrailerChange(event: string) {
    this.formatSlipTrailer = event.replace(/\n/g, "\\n");
  }*/


  public onSlipHeaderChange(value: string) {
    this.formatSlipHeader = "" + this.formatNotes(value);
    this.slipHeader.setValue(this.formatNotes(value));

  }

  public onSlipTrailerChange(value: string) {
    this.formatSlipTrailer = "" + this.formatNotes(value);
    this.slipTrailer.setValue(this.formatNotes(value));
  }

  formatNotes = (value: String): String => {

    const escapedValue = value.replace(/\n/g, "\\n");

    // Split the input value by newlines
    const lines = escapedValue.split('\\n');

    const formattedText = lines.map((line) => {
      var format_input = line.length > 24 ? line.slice(0, 24) + '\n' + line.slice(24) : line;
      return format_input;
    });

    return formattedText.join('\n');
  }

  formatSH(slipHeader: string): string {
    const lines = slipHeader.split('\n');
    if (lines.length > 1) {

      const formattedText = lines.map((line) => {
        var format_input = line + '\\n';
        return format_input;
      });
      var response1 = formattedText.join();
      var response2 = formattedText.join(' ');
      return response2;
      //return slipHeader.replace('\n', "\\n");

    }
    return slipHeader.replace('\n', "\\n");
  }

  formatST(slipTrailer: string): string {
    const lines = slipTrailer.split('\n');
    if (lines.length > 1) {

      const formattedText = lines.map((line) => {
        var format_input = line + '\\n';
        return format_input;
      });
      var response1 = formattedText.join();
      var response2 = formattedText.join(' ');
      return response2;

    }
    return slipTrailer.replace('\n', "\\n");
  }


  public onSlipTrailerKeyPress(event: Event) {
    this.formatSlipTrailer = this.slipTrailer.value.replace(/\n/g, "\\n");

    const textArray = this.formatSlipTrailer.split('\\n');
    let count: number = 0;
    var globalValue = '';

    textArray.forEach((value, index) => {
      count++;
      if (value.length > 10) {
        let firstPart = value.substr(0, 10);
        let lastPart = value.substr(10);
        globalValue = globalValue.concat(firstPart.concat("\\n", lastPart));
      }
      else {
        if (count == textArray.length) {
          globalValue = globalValue.concat(value);
        }
        else {
          globalValue = globalValue.concat(value, "\\n");
        }
      }

    });

    var final = globalValue.replace(/\\n/g, '\n');
    this.slipTrailer.setValue(final);
    return;
    ////set cursor to the last edited value
    //var elem = document.getElementById("slipTrailer");

    //if (elem != null) {
    //  if (elem.createTextRange) {
    //    var range = elem.createTextRange();
    //    range.move('character', caretPos);
    //    range.select();
    //  }
    //  else {
    //    if (elem.selectionStart) {
    //      elem.focus();
    //      elem.setSelectionRange(caretPos, caretPos);
    //    }
    //    else
    //      elem.focus();
    //  }
    //}


  }

  public omit_special_char_for_address(event) {

    var k;
    k = event.charCode;//         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44);
  }

  public async save(): Promise<void> {

    if (this.merchantNumber.invalid || this.cardAcceptorConfigFormControl.invalid || this.shopName.invalid || this.city.invalid ||
      this.governmentalConditionFormControl.invalid || this.cardSetFormControl.invalid || this.countryFormControl.invalid || this.regionFormControl.invalid || this.merchantTypeFormControl.invalid || this.postalServiceCode.invalid) {
      this.merchantNumber.markAsTouched();
      this.cardAcceptorConfigFormControl.markAsTouched();
      this.shopName.markAsTouched();
      this.city.markAsTouched();
      this.town.markAsTouched();
      this.postalServiceCode.markAsTouched();
      this.independentSalesOrganizationId.markAsTouched();
      this.independentSalesOrganizationIdVisa.markAsTouched();
      this.paymentFacilitatorId.markAsTouched();
      this.paymentFacilitatorIdVisa.markAsTouched();
      this.subMerchantId.markAsTouched();
      this.customerServicePhoneNo.markAsTouched();
      this.merchantStreetAddress.markAsTouched();
      this.merchantVerificationValue.markAsTouched();
      this.cardSetFormControl.markAsTouched();
      this.countryFormControl.markAsTouched();
      this.regionFormControl.markAsTouched();
      this.merchantTypeFormControl.markAsTouched();

      this.submitted = true;

      this.raiseErrors = true;
      this.errorMessage = "'Merchant details' tab is invalid.";

    } else {
      if (!this.creatingNew) {
        //Update merchant details this.canEdit
        if (this.canEdit && (this.merchantNumber.dirty || this.cardSetFormControl.dirty || this.cardAcceptorConfigFormControl.dirty
          || this.governmentalConditionFormControl.dirty || this.regionFormControl.dirty || this.shopName.dirty || this.city.dirty || this.town.dirty || this.postalServiceCode.dirty || this.slipHeader.dirty
          || this.subMerchantId.dirty || this.independentSalesOrganizationId.dirty || this.independentSalesOrganizationIdVisa.dirty || this.paymentFacilitatorId.dirty || this.paymentFacilitatorIdVisa.dirty || this.customerServicePhoneNo.dirty || this.merchantStreetAddress.dirty || this.merchantVerificationValue.dirty
          || this.merchantTypeFormControl.dirty || this.slipTrailer.dirty || this.countryFormControl.dirty) === true) {


          this.addUpdateMerchant.merchantNumber = this.merchantNumber.value;
          this.addUpdateMerchant.cardAcceptorConfigId = +this.cardAcceptorConfigFormControl.value;
          this.addUpdateMerchant.cardSet = this.cardSetFormControl.value;
          this.addUpdateMerchant.city = this.city.value;
          this.addUpdateMerchant.town = this.town.value;
          this.addUpdateMerchant.postalServiceCode = '' + this.postalServiceCode.value;

          if (this.displayIndependentSalesOrganizationId) {
            if (!!this.independentSalesOrganizationId.value) {
              this.addUpdateMerchant.independentSalesOrgId = this.independentSalesOrganizationId.value;
            } else {
              this.submitted = true;
              this.independentSalesOrganizationId.setValue('');
              return;
            }
          }

          if (this.displayIndependentSalesOrganizationIdVisa) {
            if (!!this.independentSalesOrganizationIdVisa.value) {
              this.addUpdateMerchant.independentSalesOrgIdVisa = this.independentSalesOrganizationIdVisa.value;
            } else {
              this.submitted = true;
              this.independentSalesOrganizationIdVisa.setValue('');
              return;
            }
          }

          if (this.displaySubMerchantId) {
            if (!!this.subMerchantId.value) {
              this.addUpdateMerchant.subMerchantId = this.subMerchantId.value;
            } else {
              this.submitted = true;
              this.subMerchantId.setValue('');
              return;
            }
          }

          if (this.displayPaymentFacilitatorId) {
            if (!!this.paymentFacilitatorId.value) {
              this.addUpdateMerchant.paymentFacilitatorId = this.paymentFacilitatorId.value;
            } else {
              this.submitted = true;
              this.paymentFacilitatorId.setValue('');
              return;
            }
          }

          if (this.displayPaymentFacilitatorIdVisa) {
            if (!!this.paymentFacilitatorIdVisa.value) {
              this.addUpdateMerchant.paymentFacilitatorIdVisa = this.paymentFacilitatorIdVisa.value;
            } else {
              this.submitted = true;
              this.paymentFacilitatorIdVisa.setValue('');
              return;
            }
          }

          if (this.displayCustomerServicePhoneNo) {
            if (!!this.customerServicePhoneNo.value) {
              this.addUpdateMerchant.customerServicePhoneNo = this.customerServicePhoneNo.value;
            } else {
              this.submitted = true;
              this.customerServicePhoneNo.setValue('');
              return;
            }
          }

          if (this.displayMerchantStreetAddress) {
            if (!!this.merchantStreetAddress.value) {
              this.addUpdateMerchant.merchantStreetAddress = this.merchantStreetAddress.value;

            } else {
              this.submitted = true;
              this.merchantStreetAddress.setValue('');
              return;
            }
          }

          if (this.displayMerchantVerificationValue) {
            if (!!this.merchantVerificationValue.value) {
              this.addUpdateMerchant.merchantVerificationValue = this.merchantVerificationValue.value;

            } else {
              this.submitted = true;
              this.merchantVerificationValue.setValue('');
              return;
            }
          }

          this.addUpdateMerchant.countryCode = this.countryFormControl.value;
          this.addUpdateMerchant.merchantType = this.merchantTypeFormControl.value;
          this.addUpdateMerchant.regionCode = this.regionFormControl.value;
          this.addUpdateMerchant.shopName = this.removeCRLFCharacter(this.shopName.value);
          //this.addUpdateMerchant.slipHeader = (this.formatSlipHeader == null || this.formatSlipHeader == undefined ? this.slipHeader.value.replace(/\\n/g, '\n') : this.formatSlipHeader);
          //this.addUpdateMerchant.slipTrailer = (this.formatSlipTrailer == null || this.formatSlipTrailer == undefined ? this.slipTrailer.value.replace(/\\n/g, '\n') : this.formatSlipTrailer);
          this.addUpdateMerchant.slipHeader = (this.formatSlipHeader == null || this.formatSlipHeader == undefined ? this.slipHeader.value.replace(/\\n/g, '\n') : this.formatSH(this.formatSlipHeader));
          this.addUpdateMerchant.slipTrailer = (this.formatSlipTrailer == null || this.formatSlipTrailer == undefined ? this.slipTrailer.value.replace(/\\n/g, '\n') : this.formatST(this.formatSlipTrailer));
          this.addUpdateMerchant.participantId = this._userDataStore.selectedParticipant.id;

          this.addUpdateMerchant.isGovernmentalMerchant = (this.governmentalConditionFormControl.value == 'Yes' ? true : false);
          //validate if structural data is VALID

          this.raiseErrors = false;

          if (this.displayIndependentSalesOrganizationId && this.independentSalesOrganizationId.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Independent Sales Organization Id' is invalid.";
            return;
          }
          if (this.displayIndependentSalesOrganizationIdVisa && this.independentSalesOrganizationIdVisa.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Independent Sales Organization Id VISA' is invalid.";
            return;
          }
          if (this.displaySubMerchantId && this.subMerchantId.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Sub Merchant Id' is invalid.";
            return;
          }
          if (this.displayPaymentFacilitatorId && this.paymentFacilitatorId.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Payment Facilitator Id' is invalid.";
            return;
          }
          if (this.displayCustomerServicePhoneNo && this.customerServicePhoneNo.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Customer Service PhoneNo' is invalid.";
            return;
          }
          if (this.displayMerchantStreetAddress && this.merchantStreetAddress.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Merchant Street Address' is invalid.";
            return;
          }
          if (this.displayPaymentFacilitatorIdVisa && this.paymentFacilitatorIdVisa.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Payment Facilitator Id Visa' is invalid.";
            return;
          }
          if (this.displayMerchantVerificationValue && this.merchantVerificationValue.invalid) {
            this.raiseErrors = true;
            this.errorMessage = "'Merchant Verification Value' is invalid.";
            return;
          }

          this.createResult = await this._merchantService.Update(this.addUpdateMerchant);

          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");

            this.createResult = await this._merchantService.UpdateVASCustomerDetailsAndVASSellerCommission(this.addUpdateMerchant);


          } else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseErrors = true;
            this.errorMessage = this.createResult.message;
          }

          //Will prevent merchant from being updated multiple times on submit
          this._loadTabData(0);
          this.markMerchantAsPrestine();
        }

        //Update banking details

        if (this.canEdit && (this.accountHolderName.dirty || this.accountDescription.dirty || this.bankFormControl.dirty
          || this.accountTypeFormControl.dirty || this.branchCode.dirty || this.accountNumber.dirty || this.loyaltyCommission.dirty) === true) {

          if (this.bankingDetails == null) {
            this.creatingNewBankingDetail = true;
            this.bankingDetails = {
              accountDescription: '',
              accountHolderName: '',
              accountNr: '',
              accountTypeID: 0,
              bankID: 0,
              branchCode: '',
              branchName: '',
              merchantNr: '',
              commission: 0
            }
          } else {
            this.creatingNewBankingDetail = false;
          }
          if (!this.accountNumber.invalid) {

            this.bankingDetails.accountHolderName = this.accountHolderName.value;
            this.bankingDetails.accountDescription = this.accountDescription.value;
            this.bankingDetails.bankID = +this.bankFormControl.value;
            this.bankingDetails.accountTypeID = +this.accountTypeFormControl.value;
            this.bankingDetails.branchCode = this.branchCode.value;
            this.bankingDetails.accountNr = this.accountNumber.value;
            this.bankingDetails.merchantNr = this.addUpdateMerchant.merchantNumber;
            this.bankingDetails.branchName = this.branchName.value;
            this.bankingDetails.commission = +this.loyaltyCommission.value;
            if (this.bankingDetails.bankID == 0) {
              this.createResult = { success: true, message: "Bank is required!" };
              this._toastService.error("Bank is required!", "Error");
            } else if (this.bankingDetails.accountTypeID == 0) {
              this.createResult = { success: true, message: "Account type is required!" };
              this._toastService.error("Account type is required!", "Error");
            } else if (this.bankingDetails.accountNr == null || this.bankingDetails.accountNr == "") {
              this.createResult = { success: true, message: "Account number is required!" };
              this._toastService.error("Account number is required!", "Error");
            } else {
              if (this.creatingNewBankingDetail) {
                this.createResult = await this._merchantService.AddBankingDetails(this.bankingDetails);
              } else {
                this.createResult = await this._merchantService.UpdateBankingDetails(this.bankingDetails);
              }

              if (this.createResult.success) {
                this._toastService.success(this.createResult.message, "Success");
              } else {
                this._toastService.error(this.createResult.message, "Error");
              }
              this.raiseErrors = false;
              this.markBankingAsPrestine();
            }
          } else {
            this.raiseErrors = true;
            this.errorMessage = "'Banking details' tab is invalid.";
          }
        }

        //Update contact details
        if (this.canEdit && (this.contactName.dirty || this.contactSurname.dirty || this.contactNumber.dirty
          || this.cellNumber.dirty || this.emailAddress.dirty) === true) {

          if (this.contactDetails == null) {
            this.contactDetails = {
              directNumber: '',
              emailAddress: '',
              faxNumber: '',
              firstName: '',
              jobTitle: '',
              merchantNr: '',
              mobileNumber: '',
              surname: '',
              workNumber: '',
              url: ''
            }
            this.creatingNewContactDetail = true;
          } else {
            this.creatingNewContactDetail = false;
          }

          this.contactDetails.firstName = this.contactName.value;
          this.contactDetails.surname = this.contactSurname.value;
          this.contactDetails.directNumber = this.contactNumber.value;
          this.contactDetails.mobileNumber = this.cellNumber.value;
          this.contactDetails.emailAddress = this.emailAddress.value;
          this.contactDetails.url = this.url.value;

          if (this.emailAddress.value && this.emailAddress.invalid) {
            return;
          }

          this.contactDetails.merchantNr = this.addUpdateMerchant.merchantNumber;
          if (this.creatingNewContactDetail) {
            this.createResult = await this._merchantService.AddContactDetails(this.contactDetails);
          } else {
            this.createResult = await this._merchantService.UpdateContactDetails(this.contactDetails);
          }

          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");
          } else {
            this._toastService.error(this.createResult.message, "Error");
          }
          this.markContactAsPrestine();

        }

        //Update Commission details
        if (this.canEdit && (this.isCommissionDirty()) === true) {
          for (const item of this.commissionDetails) {

            for (const comm of this.commissionFC) {
              if (comm.commissionDetails.cardID == item.cardID) {
                item.cardID = comm.commissionDetails.cardID;
                item.commission = comm.formControl.value;
                item.name = comm.commissionDetails.name;
              }

            }
          }

          //validate if banking details exist.
          this.bankingDetails = await this._merchantService.GetBankingDetails(this.addUpdateMerchant.merchantNumber, this._userDataStore.selectedParticipant.id.toString());
          if (this.bankingDetails == undefined) {
            this._toastService.error("Please add banking details before adding commission details!", "Error");
          } else {
            this.createResult = await this._merchantService.UpdateCommissionDetails(this.addUpdateMerchant.merchantNumber, this.commissionDetails);

            if (this.createResult.success) {
              this._toastService.success(this.createResult.message, "Success");
            } else {
              this._toastService.error(this.createResult.message, "Error");
            }
          }
          //Mark fields as Pristine
          for (const commissionFields of this.commissionFC) {
            commissionFields.formControl.markAsPristine();
          }
        }

        //Update VAS details
        if (this.canEdit && (this.lowBalanceThreshold.dirty) === true) {
          if (this.vasCustomerBalanceDetails == null) {
            this.creatingNewVASDetails = true;
            this.vasCustomerBalanceDetails = {
              currentBalance: 0,
              customerBalanceID: 0,
              customerSystemID: '',
              lowBalanceNotificationStatus: 0,
              lowBalanceThreshold: 0
            }
          } else {
            this.creatingNewVASDetails = false;
          }

          this.vasCustomerBalanceDetails.lowBalanceThreshold = +this.lowBalanceThreshold.value;
          this.vasCustomerBalanceDetails.customerSystemID = this.addUpdateMerchant.merchantNumber;
          this.vasCustomerBalanceDetails.currentBalance = this.vasCustomerBalanceDetails.currentBalance
          this.vasCustomerBalanceDetails.lowBalanceThreshold = this.vasCustomerBalanceDetails.lowBalanceThreshold

          if (this.creatingNewVASDetails == true) {
            this.createResult = await this._merchantService.AddVASCustomerBalanceDetails(this.vasCustomerBalanceDetails);
          } else {
            this.createResult = await this._merchantService.UpdateVASCustomerBalanceDetails(this.vasCustomerBalanceDetails);
          }


          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");
          } else {
            this._toastService.error(this.createResult.message, "Error");
          }
          this.lowBalanceThreshold.markAsPristine();
        }

        //Update Custom Services
        if (this.canEdit && (this.merchantParamsFC.length !== 0)) {
          let failed = false;

          let createParams: merchantParamsModel[] = [];
          let updateParams: merchantParamsModel[] = [];

          this.merchantParamsFC.forEach(element => {
            element.merchantParam.value = element.formControl.value.toString();
            if (element.merchantParam.id === 0) {
              createParams.push(element.merchantParam);
            } else {
              updateParams.push(element.merchantParam);
            }
          });

          if (createParams.length > 0) {
            let createResult = await this._merchantService.CreateMerchantParams(createParams);
            if (!createResult.success) {
              failed = true;
            }
          }

          if (updateParams.length > 0 && !failed) {
            let updateResult = await this._merchantService.UpdateMerchantParams(updateParams);
            if (!updateResult.success) {
              failed = true;
            }
          }

          if (!failed) {
            this.getMerchantServices(this.addUpdateMerchant.merchantNumber);
            this.getMerchantParams();
            this._toastService.success('Merchant Params Saved', 'Success');
          }
        }

        //Update SinkNodeMapped
        if (this.canEdit && (this.isMappedFieldsDirty())) {
          for (const item of this.sinkNodeMappedFields) {
            for (const mappedField of this.mappedFieldsFC) {
              if (mappedField.sinkNodeMappedFields.sinkNode === item.sinkNode) {
                item.cardAcceptorId = mappedField.sinkNodeMappedFields.cardAcceptorId ? mappedField.sinkNodeMappedFields.cardAcceptorId : this.addUpdateMerchant.merchantNumber;
                item.description = mappedField.sinkNodeMappedFields.description;
                item.mappedAcquiringInst = mappedField.sinkNodeMappedFields.mappedAcquiringInst;
                item.sinkNode = mappedField.sinkNodeMappedFields.sinkNode;
                item.mappedCardAcceptorId = mappedField.formControl.value.toString();
              }
            }
          }

          this.createResult = await this._merchantService.UpdateSinkNodeMappedFields(this.addUpdateMerchant.merchantNumber, this.sinkNodeMappedFields);
          if (this.createResult.success) {
            if (this.createResult.message != "No changes made on Sink Nodes") {
              this._toastService.success(this.createResult.message, "Success");
            }
          } else {
            this._toastService.error(this.createResult.message, "Error");
          }

          //Mark fields as Pristine
          for (const mappedFields of this.mappedFieldsFC) {
            mappedFields.formControl.markAsPristine();
          }
        }

      } else {
        //Adding a new Merchant
        if (this.canEdit === true && (this.merchantNumber.dirty || this.cardSetFormControl.dirty || this.countryFormControl.dirty
          || this.governmentalConditionFormControl.dirty || this.regionFormControl.dirty || this.shopName.dirty || this.city.dirty || this.town.dirty || this.postalServiceCode.dirty || this.slipHeader.dirty
          || this.subMerchantId.dirty || this.independentSalesOrganizationId.dirty || this.independentSalesOrganizationIdVisa.dirty || this.paymentFacilitatorId.dirty || this.paymentFacilitatorIdVisa.dirty || this.customerServicePhoneNo.dirty || this.merchantStreetAddress.dirty || this.merchantVerificationValue.dirty
          || this.merchantTypeFormControl.dirty || this.slipTrailer.dirty || this.cardAcceptorConfigFormControl.dirty) === true) {
          this.addUpdateMerchant.merchantNumber = this.merchantNumber.value;
          this.addUpdateMerchant.cardAcceptorConfigId = +this.cardAcceptorConfigFormControl.value;
          this.addUpdateMerchant.cardSet = this.cardSetFormControl.value;
          this.addUpdateMerchant.city = this.city.value;
          this.addUpdateMerchant.town = this.town.value;
          this.addUpdateMerchant.postalServiceCode = this.postalServiceCode.value;
          this.addUpdateMerchant.countryCode = this.countryFormControl.value;
          this.addUpdateMerchant.merchantType = this.merchantTypeFormControl.value;
          //this.addUpdateMerchant.slipHeader = (this.formatSlipHeader == null || this.formatSlipHeader == undefined ? this.slipHeader.value : this.formatSlipHeader);
          //this.addUpdateMerchant.slipTrailer = (this.formatSlipTrailer == null || this.formatSlipTrailer == undefined ? this.slipTrailer.value : this.formatSlipTrailer);
          this.addUpdateMerchant.slipHeader = (this.formatSlipHeader == null || this.formatSlipHeader == undefined ? this.slipHeader.value : this.formatSH(this.formatSlipHeader));
          this.addUpdateMerchant.slipTrailer = (this.formatSlipTrailer == null || this.formatSlipTrailer == undefined ? this.slipTrailer.value : this.formatST(this.formatSlipTrailer));

          this.addUpdateMerchant.regionCode = this.regionFormControl.value;
          this.addUpdateMerchant.shopName = this.removeCRLFCharacter(this.shopName.value);
          this.addUpdateMerchant.participantId = this._userDataStore.selectedParticipant.id;

          this.addUpdateMerchant.isGovernmentalMerchant = (this.governmentalConditionFormControl.value == 'Yes' ? true : false);

          //PFI - Payment Facilitator feature


          if (this.displayIndependentSalesOrganizationId) {
            if (!!this.independentSalesOrganizationId.value) {
              this.addUpdateMerchant.independentSalesOrgId = this.independentSalesOrganizationId.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayIndependentSalesOrganizationIdVisa) {
            if (!!this.independentSalesOrganizationIdVisa.value) {
              this.addUpdateMerchant.independentSalesOrgIdVisa = this.independentSalesOrganizationIdVisa.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displaySubMerchantId) {
            if (!!this.subMerchantId.value) {
              this.addUpdateMerchant.subMerchantId = this.subMerchantId.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayPaymentFacilitatorId) {
            if (!!this.paymentFacilitatorId.value) {
              this.addUpdateMerchant.paymentFacilitatorId = this.paymentFacilitatorId.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayPaymentFacilitatorIdVisa) {
            if (!!this.paymentFacilitatorIdVisa.value) {
              this.addUpdateMerchant.paymentFacilitatorIdVisa = this.paymentFacilitatorIdVisa.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayCustomerServicePhoneNo) {
            if (!!this.customerServicePhoneNo.value) {
              this.addUpdateMerchant.customerServicePhoneNo = this.customerServicePhoneNo.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayMerchantStreetAddress) {
            if (!!this.merchantStreetAddress.value) {
              this.addUpdateMerchant.merchantStreetAddress = this.merchantStreetAddress.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }

          if (this.displayMerchantVerificationValue) {
            if (!!this.merchantVerificationValue.value) {
              this.addUpdateMerchant.merchantVerificationValue = this.merchantVerificationValue.value;
            } else {
              this.displayIsoContentError = true;
              return;
            }
          }


          this.createResult = await this._merchantService.Add(this.addUpdateMerchant);

          if (this.createResult.success === true) {
            this._toastService.success(this.createResult.message, "Success");

            this.createResult = await this._merchantService.UpdateVASCustomerDetailsAndVASSellerCommission(this.addUpdateMerchant);

            this.newMerchantCreation = true;
          } else {
            this._toastService.error(this.createResult.message, "Error");
            this.newMerchantCreation = false;
          }

          this.markMerchantAsPrestine();
        }

        //Add banking details
        if (this.canEdit && (this.accountHolderName.dirty || this.accountDescription.dirty || this.bankFormControl.dirty
          || this.accountTypeFormControl.dirty || this.branchCode.dirty || this.accountNumber.dirty || this.loyaltyCommission.dirty) === true) {

          if (!this.accountNumber.invalid) {

            this.bankingDetails.accountHolderName = this.accountHolderName.value;
            this.bankingDetails.accountDescription = this.accountDescription.value;
            this.bankingDetails.bankID = +this.bankFormControl.value;
            this.bankingDetails.accountTypeID = +this.accountTypeFormControl.value;
            this.bankingDetails.branchCode = this.branchCode.value;
            this.bankingDetails.accountNr = this.accountNumber.value;
            this.bankingDetails.branchName = this.branchName.value;
            this.bankingDetails.merchantNr = this.addUpdateMerchant.merchantNumber;
            this.bankingDetails.commission = this.loyaltyCommission.value;

            if (this.bankingDetails.bankID == 0) {
              this.createResult = { success: true, message: "Bank is required!" };
              this._toastService.error("Bank is required!", "Error");
            } else if (this.bankingDetails.accountTypeID == 0) {
              this.createResult = { success: true, message: "Account type is required!" };
              this._toastService.error("Account type is required!", "Error");
            } else if (this.bankingDetails.accountNr == null || this.bankingDetails.accountNr == "") {
              this.createResult = { success: true, message: "Account number is required!" };
              this._toastService.error("Account number is required!", "Error");
            } else {

              //Only save if merchant was created successfully
              if (this.newMerchantCreation == true) {
                this.bankingDetails.commission = +this.bankingDetails.commission;
                this.createResult = await this._merchantService.AddBankingDetails(this.bankingDetails);

                if (this.createResult.success) {
                  this._toastService.success(this.createResult.message, "Success");
                } else {
                  this._toastService.error(this.createResult.message, "Error");
                }
                this.markBankingAsPrestine();
              }
            }
          }
        }

        //Add contact details
        if (this.canEdit && (this.contactName.dirty || this.contactSurname.dirty || this.contactNumber.dirty
          || this.cellNumber.dirty || this.emailAddress.dirty || this.url.dirty) === true) {

          this.contactDetails.firstName = this.contactName.value;
          this.contactDetails.surname = this.contactSurname.value;
          this.contactDetails.directNumber = this.contactNumber.value;
          this.contactDetails.mobileNumber = this.cellNumber.value;
          this.contactDetails.emailAddress = this.emailAddress.value;
          this.contactDetails.merchantNr = this.addUpdateMerchant.merchantNumber;
          this.contactDetails.url = this.url.value;

          if (this.emailAddress.value && this.emailAddress.invalid) {
            return;
          }

          //Only save if merchant was created successfully
          if (this.newMerchantCreation == true) {
            this.createResult = await this._merchantService.AddContactDetails(this.contactDetails);

            if (this.createResult.success) {
              this._toastService.success(this.createResult.message, "Success");
            } else {
              this._toastService.error(this.createResult.message, "Error");
            }
            this.markContactAsPrestine();
          }
        }

        //Add commission details
        if (this.canEdit && (this.isCommissionDirty()) === true) {

          if (!!this.commissionDetails) {
            for (const item of this.commissionDetails) {

              for (const comm of this.commissionFC) {
                if (comm.commissionDetails.cardID == item.cardID) {
                  item.cardID = comm.commissionDetails.cardID;
                  item.commission = comm.formControl.value;
                  item.name = comm.commissionDetails.name;
                }
              }
            }

            //Only save if merchant was created successfully
            if (this.newMerchantCreation == true) {
              //validate if banking details exist.
              this.bankingDetails = await this._merchantService.GetBankingDetails(this.addUpdateMerchant.merchantNumber, this._userDataStore.selectedParticipant.id.toString());
              if (this.bankingDetails.bankID == undefined) {
                this._toastService.error("Please add banking details before adding commission details!", "Error");
              } else {
                this.createResult = await this._merchantService.AddCommissionDetails(this.addUpdateMerchant.merchantNumber, this.commissionDetails);

                if (this.createResult.success) {
                  this._toastService.success(this.createResult.message, "Success");
                } else {
                  this._toastService.error(this.createResult.message, "Error");
                }
              }
              //Mark fields as Pristine
              for (const commissionFields of this.commissionFC) {
                commissionFields.formControl.markAsPristine();
              }
            }
          }
        }

        //Add VAS details
        if (this.canEdit && (this.lowBalanceThreshold.dirty) === true) {
          this.vasCustomerBalanceDetails.lowBalanceThreshold = +this.lowBalanceThreshold.value;
          this.vasCustomerBalanceDetails.customerSystemID = this.addUpdateMerchant.merchantNumber;
          this.vasCustomerBalanceDetails.currentBalance = this.vasCustomerBalanceDetails.currentBalance
          this.vasCustomerBalanceDetails.lowBalanceThreshold = this.vasCustomerBalanceDetails.lowBalanceThreshold


          //Only save if merchant was created successfully
          if (this.newMerchantCreation == true) {
            this.createResult = await this._merchantService.AddVASCustomerBalanceDetails(this.vasCustomerBalanceDetails);

            if (this.createResult.success) {
              this._toastService.success(this.createResult.message, "Success");
            } else {
              this._toastService.error(this.createResult.message, "Error");
            }

            this.lowBalanceThreshold.markAsPristine();
          }
        }

        //Add SinkNode Mapped Fields
        if (this.canEdit && (this.isMappedFieldsDirty()) === true) {

          for (const item of this.sinkNodeMappedFields) {
            for (const mappedField of this.mappedFieldsFC) {
              if (mappedField.sinkNodeMappedFields.sinkNode == item.sinkNode) {
                item.cardAcceptorId = mappedField.sinkNodeMappedFields.cardAcceptorId;
                item.description = mappedField.sinkNodeMappedFields.description;
                item.mappedAcquiringInst = mappedField.sinkNodeMappedFields.mappedAcquiringInst;
                item.sinkNode = mappedField.sinkNodeMappedFields.sinkNode;
                item.mappedCardAcceptorId = mappedField.formControl.value.toString();
              }
            }
          }

          //Only save if merchant was created successfully
          if (this.newMerchantCreation == true) {

            this.createResult = await this._merchantService.AddSinkNodeMappedFields(this.addUpdateMerchant.merchantNumber, this.sinkNodeMappedFields);

            if (this.createResult.success) {
              this._toastService.success(this.createResult.message, "Success");
            } else {
              this._toastService.error(this.createResult.message, "Error");
            }
          }
        }

        //Save Custom Services
        if (this.canEdit && (this.serviceFormControl.dirty) === true) {
          alert('Save services');
        }

        if (this.newMerchantCreation) {
          //edit merchant
          this.raiseErrors = false;
          this.errorMessage = "";
          this._router.navigate(['management', 'merchant', this.addUpdateMerchant.merchantNumber]).then(async () => {
            await this.loadSinkNodeMappedFields();
            await this.loadMappedDescriptions();
          });
        }
      }
    }
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  public async openDeleteConfirmationDialog(id: string) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Delete';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Sink Node Mapping Removal';
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected sink node <b>PERMANENTLY</b>? <br> <p style="font-size:12px; color: red"> Please note that we cannot recover after clicking the "Delete" button </p>'

    const result = await dialogRef.result;
    if (result) {
      var item = this.sinkNodeMappedFields.find(x => x.sinkNode == id);
      this.createResult = await this._merchantService.deleteSinkNode(item, this.merchantNumber.value);

      if (!this.createResult.success) {
        this._toastService.error(this.createResult.message, "Error");
        return;
      }

      this._toastService.success(this.createResult.message, "Success");
      const index = this.sinkNodeMappedFields.findIndex(x => x.sinkNode == id);
      if (index > -1) {
        this.sinkNodeMappedFields.splice(index, 1);
        this.mappedFieldsFC.splice(index, 1);
      }

      const sinknodes = await this._participantService.GetSinkNodeMappedConfigs();
      const sinknode = sinknodes.find(x => x.sinknode === item.sinkNode);
      if (sinknode !== undefined) {
        this.sinkNodeMappingConfigs.push(sinknode);
      }
    }
  }

  private async loadSinkNodeMappedFields() {
    let sinkNodeMappedFields = [];
    if (this.addUpdateMerchant.merchantNumber !== '') {
      const mappedSinkNods = await this._merchantService.GetSinkNodeMappedFields(this.addUpdateMerchant.merchantNumber);
      mappedSinkNods.forEach(element => {
        if (element.description != 'Aggregator' && element.mappedCardAcceptorId !== '') {
          sinkNodeMappedFields.push(element);
        }
      });
    }
    return sinkNodeMappedFields;
  }

  private async loadMappedDescriptions() {
    if (this.isoPfiMappedDescription === "") {
      if (this.addUpdateMerchant.merchantNumber !== '') {
        var isoPfiSinkNode = await this._merchantService.GetISOPfiSinkNode(this.addUpdateMerchant.merchantNumber);
        if (isoPfiSinkNode) {
          this.isoPfiMappedDescription = isoPfiSinkNode.description;
        }
      }
    }

    for (const item of this.sinkNodeMappedFields) {
      const mappedField = new FormControl();
      let disable = false;

      mappedField.setValue("" + item.mappedCardAcceptorId);
      if (!this.canEdit && this.canView) {
        mappedField.disable();
      }

      if (item.description == "Mapped_ISO") {
        mappedField.disable();
        disable = true;
      }

      if (item.description == this.isoPfiMappedDescription) {
        mappedField.disable();
        disable = true;
      }

      if (item.description == "Aggregator") {
        mappedField.disable();
        disable = true;
      }

      //If there are duplicates remove them to have the latest version
      var existing = this.mappedFieldsFC.filter(x => x.sinkNodeMappedFields.description == item.description);
      if (existing.length > 0) {
        existing.forEach((element) => {
          let index = this.mappedFieldsFC.indexOf(element);
          this.mappedFieldsFC.splice(index, 1);
        });
      }
      if (item.description != "Mapped_ISO") {
        this.mappedFieldsFC.push({
          formControl: mappedField,
          sinkNodeMappedFields: item,
          disabled: disable
        });

      }
    }
  }

  private loadMerchantSettings(participant: ParticipantViewModel): void {
    if (!participant.hasBankingDetails || participant.hasBankingDetails == null) {
      this.viewBanking = false;
    } else {
      this.viewBanking = true;
    }

    if (!participant.hasContactDetails || participant.hasContactDetails == null) {
      this.viewContact = false;
    } else {
      this.viewContact = true;
    }

    if (!participant.hasCommissionDetails || participant.hasCommissionDetails == null) {
      this.viewCommission = false;
    } else {
      this.viewCommission = true;
    }

    if (!participant.hasValueAddedService || participant.hasValueAddedService == null) {
      this.viewAddedServices = false;
    } else {
      this.viewAddedServices = true;
    }

    if (!participant.removePFIDetails || participant.removePFIDetails == null) {
      this.removePFIForAggregatorModel = false;
    } else {
      this.removePFIForAggregatorModel = true;
    }
  }
}
